<template>
  <a-modal
    title="添加计划名称"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    okText="保存"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">添加计划</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ y: 260 }"
    >
      <span slot="planNameTitle">
        <i class="toRequired">*</i>计划名称
      </span>
      <span slot="planTypeTitle">
        <i class="toRequired">*</i>计划类型
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'" class="table-line">
            <a @click="handleDelete(tableList, record)">删除</a>
            <a-tag v-if="record.message" color="red" class="tag">{{ record.message }}</a-tag>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :value.sync="record[item.dataIndex]"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label }"
            />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" />
          </span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpMrpPlansAdd } from '@/api/scp/planSetting/mrpPlanName'

export default {
  props: {
    planTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '计划名称',
          width: 150,
          dataIndex: 'planName',
          scopedSlots: { customRender: 'planName', title: "planNameTitle" },
          // type: "select",
          // requestApi: "/scp/scpMrpPlans/plan_name_box",
          // value: 'realValue',
          // label: 'label'
          type: "input"
        },
        {
          title: '说明',
          width: 150,
          dataIndex: 'description',
          scopedSlots: { customRender: 'description' },
          type: "input"
        },
        {
          // title: '计划类型',
          width: 150,
          dataIndex: 'planType',
          scopedSlots: { customRender: 'planType', title: "planTypeTitle" },
          type: "select",
          dataList: 'planTypeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      tableList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        planName: "",
        description: "",
        planType: "",
        message: "",
        organizationCode: this.organizationCodeOrigin,
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].planName || !this.tableList[i].planType) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiScpMrpPlansAdd(this.tableList).then(response => {
        if (response.code === 200) {
          if (response.data && response.data.length > 0) {
            const arr = JSON.parse(JSON.stringify(this.tableList))
            arr.forEach(element => {
              element.message = ""
            });
            response.data.forEach(element => {
              arr[Number(element.lineNum) - 1].message = element.message
            });
            this.tableList = arr
            this.$message.error(response.data[0].message)
            this.confirmLoading = false
            return
          }
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 170px;
}
input{
  width: 170px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.table-line{
  position: relative;
  .tag{
    position: absolute;
    left: -420px;
    bottom: -30px;
    z-index: 10000000;
  }
}
</style>
